export default __webpack_public_path__ + "static/media/banner-mobile-image@2x.cceb440d.jpg";